import { render, staticRenderFns } from "./CardODTMaquina.vue?vue&type=template&id=60023bf7&scoped=true&"
import script from "./CardODTMaquina.vue?vue&type=script&lang=js&"
export * from "./CardODTMaquina.vue?vue&type=script&lang=js&"
import style0 from "./CardODTMaquina.vue?vue&type=style&index=0&id=60023bf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60023bf7",
  null
  
)

export default component.exports